import { isMini, isWeChat } from "@saas/components/src";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@saas/store/src";
import VueAnalytics from "vue-analytics";
import "@saas/components/src/plugins/elementUI.js";
import "@saas/components/src/plugins/directive.js";
import "amfe-flexible/index.js";
import "@saas/components/src/components/message/index.js";
import DialogPlugin from "@saas/pages/src/login-page/Index.js";
import ErrorPage from "@saas/components/src/components/error-page/index.js";
import OfflinePlugin from "@saas/components/src/components/offline-dialog/index.js";
//模版页面
import defaultPage from "../../layout/default.vue";
import agreementPage from "../../layout/agreement.vue";
// import "@/assets/font/zhixin/iconfont.css";
// import "@/assets/font/zhixin-web/iconfont.css";
import "@/assets/font/saas/iconfont.css";
import "@/assets/css/tailwendcss.css";
//过滤器
import "@saas/components/src/utils/filters";
import "../public/stylesheets/element-variables.scss";
import Empty from "@saas/components/src/components/empty/Index";
import "@saas/components/src/components/loading/index";
// 字体文件
import "@/assets/font/Avenir/Avenir.css";
// 数据交互
import "@saas/components/src/utils/message";
import "katex/dist/katex.min.css";
import { DarkMessage } from "@saas/components";
import { initSentry } from "./utils/init-sentry";
Vue.config.productionTip = false;
Vue.component("default-page", defaultPage);
Vue.component("agreement-page", agreementPage);
Vue.component("Empty", Empty);
// 挂载到 Vue.prototype
Vue.use(DialogPlugin, { store, router });
Vue.use(OfflinePlugin, { store, router });
Vue.use(ErrorPage);
Vue.use(DarkMessage);
Vue.prototype.$classBell = new Audio(
  "https://cdn.moguocdn.com/cdn/static/audio/startClassBell.mp3"
);
Vue.prototype.$endClassBell = new Audio(
  "https://cdn.moguocdn.com/cdn/static/audio/endClassBell.mp3"
);
// GA初始化
if (process.env.VUE_APP_SAAS_WEB_URL.includes("moguoyunke.com")) {
  Vue.use(VueAnalytics, {
    id: "GTM-WMFDBSG3", // 从配置中读取
    disableScriptLoader: true, // 必须在html中完成初始化，这里显式禁止去下载ga脚本
    router, // 确保路由切换时可以自动统计
    autoTracking: {
      pageviewOnLoad: false, // 当通过网址进来时已经GA在初始化时就发起一次pageview的统计，这里不要重复统计
    },
  });
}
console.log("isMIni>>>>>", isMini());
console.log("isWedhat>>>>>", isWeChat());

if (!isMini()) {
  // 创建 script 元素
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://turing.captcha.qcloud.com/TJCaptcha.js";
  // 将 script 元素添加到 head 中
  document.head.appendChild(script);
  // 可以添加回调来处理脚本加载完成后的操作
  script.onload = () => {
    console.log("TCaptcha 加载完成");
  };
}
initSentry(router, store);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
